module.exports = __webpack_public_path__ + "img/service-214.45c576f8.png";